export default function handlePaginationString(actualPage: number, pagesCount: number): string {
  if (pagesCount === 0) {
    return '-';
  }
  return actualPage + '/' + pagesCount;
}
